export default "__VITE_ASSET__DVny0D____"